import C from '../../constants';

export const setIsLoading = (isLoading) => {
    return {
        type: C.SET_IS_LOADING,
        payload: isLoading
    };
};

export const showAddPropertyModal = (show) => {
    return {
        type: C.SHOW_ADD_PROPERTY_MODAL,
        payload: show
    };
};

export const showAddListingModal = (show) => {
    return {
        type: C.SHOW_ADD_LISTING_MODAL,
        payload: show
    };
};

export const showInviteTenantModal = (show) => {
    return {
        type: C.SHOW_INVITE_TENANT_MODAL,
        payload: show
    };
};

export const addFlowKey = (id, size, defaultKey) => {
    return {
        type: C.ADD_FLOW_KEY,
        payload: {id: id, size: size, value: defaultKey || 0, direction: 1}
    };
};

export const setFlowKey = (id, value) => {
    return {
        type: C.SET_FLOW_KEY,
        payload: {id: id, value: value}
    };
};

export const incFlowKey = (id) => {
    return {
        type: C.INC_FLOW_KEY,
        payload: {id: id, value: 1, direction: 1}
    };
};

export const decFlowKey = (id) => {
    return {
        type: C.INC_FLOW_KEY,
        payload: {id: id, value: -1, direction: -1}
    };
};

export const displayConfirmModal = (modalData) => {
    return {
        type: C.DISPLAY_CONFIRM_MODAL,
        payload: modalData
    };
};

export const hideConfirmModal = (id) => {
    return {
        type: C.HIDE_CONFIRM_MODAL,
        payload: id
    };
};

export const setConfirmModalActing = (id, acting) => {
    return {
        type: C.SET_CONFIRM_MODAL_ACTING,
        payload: {id: id, acting: acting}
    };
};

export const displayModal = (modalData) => {
    return {
        type: C.DISPLAY_MODAL,
        payload: modalData
    };
};

export const hideModal = (id) => {
    return {
        type: C.HIDE_MODAL,
        payload: id
    };
};

export const updateModal = (modalData) => {
    return {
        type: C.UPDATE_MODAL,
        payload: modalData
    };
};

export const displayOverlay = (overlay) => {
    return {
        type: C.DISPLAY_OVERLAY,
        payload: overlay
    };
};

export const hideOverlay = (id) => {
    return {
        type: C.HIDE_OVERLAY,
        payload: id
    };
};

export const updateOverlay = (overlay) => {
    return {
        type: C.UPDATE_OVERLAY,
        payload: overlay
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/display.js